import { Form, Select } from '@bynder/design-system';
import { useActiveWidget } from '../../../../../queries/guides';
import {
  CollectionLayoutOptions,
  CollectionWidget,
} from '../../../../../types/widgets/collections';
import { Props } from './types';
import { Translate } from '@bynder/localization';
import { capitalize } from 'lodash';
import { IconGridFill, IconMasonry } from '@bynder/icons';

const LayoutGridSelector: React.FC<Props> = ({ handleChange }) => {
  const widget = useActiveWidget() as CollectionWidget;
  const { layout } = widget.collectionSettings;

  return (
    <Form.Group>
      <Form.Label id="layout">
        <Translate id="WIDGETS_INSPECTOR.COLLECTION_LAYOUT_TITLE" />
      </Form.Label>
      <Select
        value={layout}
        onChange={value => handleChange('layout', value)}
        label={capitalize(layout)}
        aria-labelledby="layout"
        icon={
          layout === CollectionLayoutOptions.GRID ? (
            <IconGridFill />
          ) : (
            <IconMasonry />
          )
        }
      >
        <Select.Item
          value={CollectionLayoutOptions.GRID}
          icon={<IconGridFill />}
        >
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_GRID_OPTION" />
        </Select.Item>
        <Select.Item
          value={CollectionLayoutOptions.MASONRY}
          icon={<IconMasonry />}
        >
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_MASONRY_OPTION" />
        </Select.Item>
      </Select>
    </Form.Group>
  );
};

export default LayoutGridSelector;
